import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllImportRows, resetGetAllStatus } from "./slice"

export function ImportazioneList() {
    const dispatch = useAppDispatch()
    const importState = useAppSelector(state => state.notificationImport)
    const notificationState = useAppSelector(state => state.notification)

    useEffect(() => {
        dispatch(GetAllImportRows({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
    }, [])

    useEffect(() => {
        if (importState.getAllImportRowsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [importState.getAllImportRowsStatus])

    return (
        <div style={{ padding: '24px' }}>
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">N. UP</th>
                        <th className="width-[130px]">Filiera</th>
                        <th className="width-[100px]">Tipo Prodotto</th>
                        <th className="width-[130px]">Tipo Struttura</th>
                        <th className="width-[130px]">Paese</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        importState.GetAllImportResponse?.data.map((i, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{i.productiveUnitNumber}</td>
                                <td>{i.productionChain}</td>
                                <td>{i.productType}</td>
                                <td>{i.structureType}</td>
                                <td>{i.country}</td>
                                <td></td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>
    )
}